module.exports = __webpack_public_path__ + "static/img/beijing.1781503650204.png";